import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, OnDestroy, signal, WritableSignal, type OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { KuiTabsModule } from 'app/key-ui';
import { KuiTabComponent } from 'app/key-ui/tabs/tab.component';
import { KeyMediaModule } from 'app/shared/components/media/media.module';
import { SelectionItem } from 'app/shared/components/selection/selection.model';
import { Subject } from 'rxjs';

export interface LiveCamera {
    assetId: string;
    cameraId: string;
    cameraName: string;
}

@Component({
    selector: 'key-video-request-livestream',
    standalone: true,
    imports: [
        CommonModule,
        KeyMediaModule,
        TranslateModule,
        KuiTabsModule
    ],
    templateUrl: './livestream-viewer.component.html',
    styleUrl: './livestream-viewer.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VideoRequestLivestreamComponent implements OnInit, OnDestroy {

    private destroyed: Subject<void> = new Subject();

    cameras = input.required<LiveCamera[]>();
    asset = input.required<SelectionItem>();
    isActive = input.required<SelectionItem>();

    activeCamera: WritableSignal<string> = signal('');

    constructor() { }

    ngOnInit(): void {
        // Default to the first camera
        this.activeCamera.set(this.cameras()[0].cameraName);
    }

    handleTabChange(event: KuiTabComponent) {
        this.activeCamera.set(event.title);
    }

    ngOnDestroy(): void {
        this.destroyed.next();
        this.destroyed.complete();
    }

}
